import React, {useCallback, useState} from "react";
import { observer } from "mobx-react-lite";
import { Context, Cookie, Hooks } from "@xt/xtbase";
import store from "store";
import { LayoutEnum } from "store/app";
import Storage from "utils/storage";

import { Drawer, Switch } from "antd";
import XtSvg from "components/xt/svg";

import styles from "./index.module.scss";
import cx from "classnames";

const { useTranslation } = Hooks;
const { XtContext } = Context;

const Main: React.FC = () => {
  const t = useTranslation();
  const [appState, appDispatch] = React.useContext(XtContext);

  const { orderConfirm_limit, orderConfirm_market } = store.trade;

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const setTheme = (theme) => {
    appDispatch({ payload: { theme } });
    Cookie.set("theme", theme);
  };

  const setLayout = (layout) => {
    store.app.updateState({ layout });
    Storage.set("layout", layout);
    onClose();
  };

  const setOrderConfirm_limit = useCallback((orderConfirm_limit) => {
    store.trade.updateState({ orderConfirm_limit });
    Storage.set("orderConfirm_limit", orderConfirm_limit);
  }, []);
  const setOrderConfirm_market = useCallback((orderConfirm_market) => {
    store.trade.updateState({ orderConfirm_market });
    Storage.set("orderConfirm_market", orderConfirm_market);
  }, []);

  return (
    <>
      <button onClick={showDrawer} className={cx("btnTxt", "btnHover", styles.trigger)}>
        <XtSvg icon={`setting`} />
      </button>
      <Drawer
        className={styles.drawer}
        closable={false}
        width={304}
        title={t("trade.preference")}
        placement="right"
        onClose={onClose}
        open={open}
        extra={
          <button className={cx("btnTxt", "btnHover", styles.closeBtn)} onClick={onClose}>
            <XtSvg icon={`close`} />
          </button>
        }
      >
        <div className={styles.content}>
          <div>
            <p>{t("trade.theme")}</p>
            <div className={styles.conTheme}>
              <button onClick={() => setTheme("dark")} className={cx("btnTxt", "btnHover", { [styles.conThemeAtv]: appState.theme === "dark" })}>
                <XtSvg icon={`theme-dark-filled`} />
                <span>{t("trade.theme_dark")}</span>
              </button>
              <button onClick={() => setTheme("light")} className={cx("btnTxt", "btnHover", { [styles.conThemeAtv]: appState.theme === "light" })}>
                <XtSvg icon={`theme-light-filled`} />
                <span>{t("trade.theme_light")}</span>
              </button>
            </div>
          </div>

          <div>
            <p>{t("trade.layout")}</p>
            <div className={styles.conLayout}>
              <div className={cx({ [styles.conThemeAtv]: store.app.layout === LayoutEnum.classic })}>
                <button onClick={() => setLayout(LayoutEnum.classic)} className={"btnTxt"}>
                  <div>
                    <span></span>
                    <span></span>
                  </div>
                </button>
                <p>{t("trade.classic")}</p>
              </div>
              <div className={cx({ [styles.conThemeAtv]: store.app.layout === LayoutEnum.advanced })}>
                <button onClick={() => setLayout(LayoutEnum.advanced)} className={"btnTxt"}>
                  <div>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>
                <p>{t("trade.advanced")}</p>
              </div>
              <div className={cx({ [styles.conThemeAtv]: store.app.layout === LayoutEnum.fullscreen })}>
                <button onClick={() => setLayout(LayoutEnum.fullscreen)} className={"btnTxt"}>
                  <div>
                    <span></span>
                    <span></span>
                  </div>
                </button>
                <p>{t("trade.fullscreen")}</p>
              </div>
            </div>
          </div>

          <div>
            <p>{t("trade.orderConfirm")}</p>
            <div className={styles.conOrderConfirm}>
              <div>
                <div>{t("trade.limitOrder")}</div>
                <Switch size="small" checked={orderConfirm_limit} onChange={setOrderConfirm_limit} />
              </div>
              <div>
                <div>{t("trade.marketOrder")}</div>
                <Switch size="small" checked={orderConfirm_market} onChange={setOrderConfirm_market} />
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default observer(Main);
